import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import InjectorWrapper from './app/shared/injector';
import { environment } from './environments/environment';
import { defineCustomElements } from '@springtree/eva-config-picker/loader';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(component => {
    InjectorWrapper.setInjector(component.injector);

    defineCustomElements(window);
  })
  .catch(err => console.log(err));
